module.exports = __webpack_public_path__ + "static/media/400245_01.505f9d8d.png";